(ns entities.review.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )


(s/def ::life-decisions (s/nilable string?))
(s/def ::memorable-events (s/nilable string?))
(s/def ::meeting-agenda (s/nilable string?))

(s/def ::review (s/nilable (s/keys :req-un [::life-decisions
                                            ::meeting-agenda
                                            ::memorable-events
                                            ])))
